<template>
  <div id="app">
    <ProgressBar></ProgressBar>
    <header class="header">
      <Logo />
    </header>
    <component
      v-for="(chapter, index) in chapters"
      :key="index"
      :is="chapter.component"
      :track="chapter.track"
    ></component>
  </div>
</template>

<script>
import ProgressBar from './components/ProgressBar'
import { Logo } from './components/icons'
import { Intro, Chapter1, Chapter2, Chapter3, Chapter4, Chapter5, Results, Footer } from './components/chapters'

export default {
  name: 'app',
  data () {
    return {
      chapters: [].concat({
        component: Intro,
        track: '00-intro'
      }, {
        component: Chapter1,
        track: '01-bestel-maar'
      }, {
        component: Chapter2,
        track: '02-de-gevolgen-van-jouw-retouren'
      }, {
        component: Chapter3,
        track: '03-het-grote-checken'
      }, {
        component: Chapter4,
        track: '04-hoe-slecht-voor-het-milieu-is-dit'
      }, {
        component: Chapter5,
        track: '05-zo-ga-jij-in-de-toekomst-online-je-kleren-passen'
      }, {
        component: Results,
        track: '06-results'
      }, {
        component: Footer,
        track: '07-footer'
      })
    }
  },
  components: {
    ProgressBar,
    Logo
  }
}
</script>

<style src="normalize.css" />
<style lang="scss" scoped>
.header {
  text-align: center;
  padding: 24px;
  margin-bottom: 26px;
}
</style>
<style lang="scss">
*,
*:before,
*:after {
  box-sizing: border-box;
}

a {
  text-decoration: none;
  color: inherit;

  &:hover,
  &:focus,
  &:visited,
  &:active {
    color: inherit;
  }
}

html,
body {
  background-color: $c-dark;
}

#app {
  overflow-x: hidden;
  font-family: $ff-barlow;
  color: white;
  font-weight: $fw-medium;
  font-size: $fs-bread;
  line-height: $lh-bread;
}

.container {
  @extend %container;
}

.row {
  @extend %row;
}

.flickity-prev-next-button {
  width: 30px;
  height: 30px;
  z-index: 10;
  padding: 0;
  border-radius: 50%;

  &.previous {
    left: -10px;
  }

  &.next {
    right: -10px;
  }
}

.flickity-button-icon {
  left: 27%;
  top: 27%;
  width: 46%;
  height: 46%;
  stroke-linejoin: round;
  stroke-linecap: round;
}

.flickity-page-dots {
  position: static;
  bottom: 0;
  margin-top: 31px;
  font-size: 0;

  .dot {
    background-color: rgba(0, 0, 0, 0.2);
    opacity: 1;
    width: 13px;
    height: 13px;
    margin: 0 5px;
    will-change: opacity;
    transition: opacity 200ms ease;
    position: relative;

    &:hover {
      opacity: 0.8;
    }

    &::after {
      content: '';
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background-color: $c-red;
      transform: scale(0);
      z-index: 1;
      transition: transform 400ms ease;
      will-change: transform;
      border-radius: 50%;
    }

    &.is-selected::after {
      transform: scale(1);
    }
  }
}
</style>
